<template>
  <div class="detailContent">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('message.messageDetail.back') }}</span>
    </div>
    <div class="header">{{ $t('message.messageDetail.header') }}</div>
    <div class="title">
      <span>{{ title }}</span>
      <span class="time">{{ time }}</span>
    </div>
    <div class="detail">
      <div class="desc">{{ $t('message.messageDetail.resourceDetail', { resource: desc }) }}</div>
      <div class="path">{{ $t('message.messageDetail.viewPath', { path: path }) }}</div>
    </div>
  </div>
</template>

<script>
import { messageDetail } from '@/api/message.js'

export default {
  data() {
    return {
      title: '',
      desc: '',
      time: '',
      path: ''
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    async getDetail() {
      const res = await messageDetail({ id: this.id })
      if (res.code === 200) {
        const data = res.data
        this.title = data.title
        const resource = data.content.find(item => item.key === 'res_detail').body
        const path = data.content.find(item => item.key === 'res_path').body
        this.desc = `${resource}`
        this.path = `${path}`
        this.time = data.createdAt
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getDetail()
  }
}

</script>

<style scoped lang="less">
.detailContent{
  padding: 18px 21px;
}
.header {
  margin-bottom: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ededed;
  font-size: 16px;
  font-weight: 800;
  color: #000000;
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  margin-top: 23px;
  span:nth-child(2){
    padding-left: 22px;
    font-weight: 400;
    font-size: 14px;
    color: #A1A1A1;
  }
}
.detail{
  width: 100%;
  background: #F8FAFC;
  border-radius: 4px;
  margin-top: 22px;
  padding: 12px 20px;
  .desc{
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
  .path{
    font-weight: 400;
    font-size: 12px;
    color: #9396A0;
    margin-top: 30px;
  }
}
</style>
